import API from "../../..";
import { fullUrl } from '../../../utile/utile.api';

/* パスワード再設定メール送信（再設定用URLをメールで送信する。認証不要） */

export type PasswordResetEmailRequestParam = {
  /** ○	ログインID */
  login_id: string,
  /** ○	担当者メールアドレス */
  responsible_person_email_address: string,
}

const path = '/reset-email';

const resetEmail = (url: string) => () => {
  const full = fullUrl(url, path);
  return ({
    post: (param: PasswordResetEmailRequestParam) => API.con
      .post<PasswordResetEmailRequestParam, {}>({ url: full, data: param }),
  })
}

export default resetEmail;
